export const SAVE_VERSION = 1;

export function loadSave<T>(key: string, fallback: T, migrate: (raw: unknown) => T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return migrate(JSON.parse(raw));
  } catch {
    return fallback;
  }
}

export function writeSave(key: string, data: Record<string, unknown>) {
  try {
    localStorage.setItem(key, JSON.stringify({ version: SAVE_VERSION, ...data }));
  } catch {
    /* quota / private mode */
  }
}

export function uniqueBingoNumbers(values: unknown): number[] {
  if (!Array.isArray(values)) return [];
  const seen = new Set<number>();
  const out: number[] = [];
  for (const value of values) {
    const n = typeof value === "number" ? value : Number(value);
    if (!Number.isInteger(n) || n < 1 || n > 75 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out;
}
